/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "background",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true shows the modal content with a darker background."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to ModalBody."
    }
];

export default documentedProperties;
